import React, { useContext } from 'react';
import { Image, } from '@fluentui/react-components';
import { EmptyState, EmptyStateContent, EmptyStateSize, EmptyStateSurfaceIcon } from '@bingads-webui-fluent-component/empty-state';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { allSiteMap, getRoutePathById } from '@bingads-webui-react/with-site-map';

import { EMPTY_STATE, EXTERNAL_LINK } from '../constants';
import { useEmptyStateStyle } from './empty-state-result-styles';
import SearchImageIcon from '../../media/search.jpg';
import SetupImageIcon from '../../media/setup.jpg';
import { I18n } from '../types';
import { NavigationPopup } from './navigation-popup';

export const emptyStateMapping = {
  [EMPTY_STATE.NoGoalInitial]: {
    title: _TL_('No conversion goals'),
    subtext1: _TL_('You can create a new conversion goal for this account on the conversion goals page.'),
    actionButton: true,
    actionButtonTitle: _TL_('Create conversion goals'),
    siteMapId: EXTERNAL_LINK.CONVERSION_GOAL,
    image: SetupImageIcon,
  },
  [EMPTY_STATE.SearchEmpty]: {
    title: _TL_('No results found'),
    subtext1: _TL_('Please search again using a conversion goal name.'),
    actionButton: false,
    actionButtonTitle: '',
    image: SearchImageIcon,
  },
};

interface EmptyStateResultComponentProps {
  i18n: I18n;
  isCreationWorkflow: boolean | undefined;
  emptyState: typeof EMPTY_STATE[keyof typeof EMPTY_STATE];
  activityLogger: {
    trace: (data: any) => void;
  };
}

export const EmptyStateResultComponent: React.FC<EmptyStateResultComponentProps> = ({
  i18n, emptyState, isCreationWorkflow, activityLogger,
}) => {
  const classes = useEmptyStateStyle();
  const config = emptyStateMapping[emptyState];
  const { scope } = useContext(ScopeContext) as any;

  const defaultOnClick = (siteMapId) => {
    if (activityLogger && activityLogger.trace) {
      activityLogger.trace(`[GoalSelectorV3] navigate to: ${siteMapId} based on ${config.title}`);
    }
    scope.history.push({
      pathname: getRoutePathById(allSiteMap, siteMapId),
      search: scope.history.location.search,
    });
  };

  return (
    <div className={classes.emptyStateWrap}>
      <EmptyState size={EmptyStateSize.largeSurface}>
        <EmptyStateContent
          title={i18n.getString(config.title)}
          subtext={i18n.getString(config.subtext1)}
        >
          <EmptyStateSurfaceIcon>
            <Image src={config.image} width="52" alt={i18n.getString(_TL_('empty result icon'))} />
          </EmptyStateSurfaceIcon>

        </EmptyStateContent>
        {config.actionButton ?
          <NavigationPopup className={classes.emptyStateLink} appearance="secondary" i18n={i18n} onNavigation={() => defaultOnClick(config.siteMapId)} enabled={isCreationWorkflow} confirmButtonText={i18n.getString(config.actionButtonTitle)} />
        : null }
      </EmptyState>
    </div>
  );
};
